import React, { useEffect, useRef, useState } from "react";

// TradingView's signature detail: when the price ticks, only the digits that
// actually changed flash green/red for ~600ms, then fade back to white.
// We diff the formatted string and flash the changed suffix.
export default function FlashPrice({ value, format, className = "" }) {
  const text = format ? format(value) : String(value ?? "—");
  const prevText = useRef(text);
  const [flash, setFlash] = useState({ from: text.length, dir: 0, id: 0 });
  const timer = useRef(null);

  useEffect(() => {
    const prev = prevText.current;
    if (prev !== text && value != null) {
      // first index (from the left) where the strings diverge
      let i = 0;
      const min = Math.min(prev.length, text.length);
      while (i < min && prev[i] === text[i]) i += 1;
      const dir = Number(text.replace(/[^0-9.]/g, "")) >= Number(prev.replace(/[^0-9.]/g, "")) ? 1 : -1;
      setFlash({ from: i, dir, id: Date.now() });
      clearTimeout(timer.current);
      timer.current = setTimeout(() => setFlash((f) => ({ ...f, dir: 0 })), 600);
    }
    prevText.current = text;
    return () => clearTimeout(timer.current);
  }, [text, value]);

  const head = text.slice(0, flash.from);
  const tail = text.slice(flash.from);
  const flashColor = flash.dir === 1 ? "text-emerald-400" : flash.dir === -1 ? "text-rose-400" : "";

  return (
    <span className={`tabular-nums font-mono transition-colors duration-500 ${className}`}>
      {head}
      <span key={flash.id} className={`transition-colors duration-500 ${flashColor}`}>
        {tail}
      </span>
    </span>
  );
}
